<script setup>

import {ref, onMounted, computed} from 'vue';
import BlockTable from './BlockTable.vue';
import BlockChart from './BlockChart.vue';
import BlockSplitBar from './BlockSplitBar.vue';
import BlockText from './BlockText.vue';
import BlockRisk from './BlockRisk.vue';
import BlockPerformance from './BlockPerformance.vue';

const props = defineProps({
  sectionData: Object,
  factsheetData: Object,
  sectionIndex: Number,
  isPrintView: Boolean
})
var toggled = ref(true);


onMounted(() => {
  if (props.sectionIndex > 1) {
    toggled.value = false;
  }
})

const toggleItem = function () {
  toggled.value = !toggled.value;
}

const factsheetURL= computed(() => {
  return process.env.VUE_APP_URL
})

</script>

<template>
  <section class="section">
    <h2 v-on:click="toggleItem" class="section-title">{{ props.sectionData.header }}
      <img class="expander-button" :src="factsheetURL + '/assets/icon-plus.svg'"
        alt="Open" v-if="!toggled && !props.isPrintView">
      <img class="expander-button" :src="factsheetURL + '/assets/icon-minus.svg'"
        alt="Close" v-if="toggled && !props.isPrintView">
    </h2>
    <div class="toggled-content" v-if="toggled || props.isPrintView" v-for="block in props.sectionData.blocks" :key="block.id">
      <BlockChart v-if="block.type === 'Chart'" :blockData="block.data" />
      <BlockTable v-if="block.type === 'Table'" :blockData="block.data" />
      <BlockText v-if="block.type === 'Text'" :blockData="block.data" />
      <BlockPerformance v-if="block.type === 'Performance'" :blockData="block.data" :fundName="props.factsheetData.name"
        :as-at-date="props.factsheetData.as_at_date" :hasBenchmark="props.factsheetData.has_benchmark"
        :fundData="props.factsheetData.fund_data" />
      <BlockRisk v-if="block.type === 'Risk'" :blockData="block.data" />
      <BlockSplitBar v-if="block.type === 'Split Bar'" :blockData="block.data" />
    </div>
  </section>
</template>

<style scoped>
$red: #de261c;

section.section {
  padding-bottom: 5px;
}

/deep/ .section-title {
  cursor: pointer;
  display: inline-block;

  &:hover {
    opacity: 0.8;
  }

  .expander-button {
    padding-left: 10px;
  }
}

@media print {
  .toggled-content {
    display: block !important;
  }

  .expander-button {
    display: none;
  }
}
</style>
